SupportRedemptionInstructionsPopupView = require('../redemption_instructions_popup_view')
SupportServiceActionsBaseView = require('./service_action_base')
SupportServiceActionButtonTemplate = require('../../../../service_action_button.html.mustache')

class SupportRedemptionInstructionsServiceActionView extends SupportServiceActionsBaseView
  id: 'redemption_instruction'

  initialize: (options)->
    _.bindAll.apply(_, [this].concat(_.functions(this)))
    @I18nScope = 'modules.support'
    @template = SupportServiceActionButtonTemplate
    @order = Groupon.Support.currentOrder

  render: ->
    @$el.append toHtml(@template, @toHash(), @I18nScope)

  toHash: ->
    hash =
      service_action_id : "redemption_instruction",
      service_action : I18n.t("js.modules.support.view_redemption_instructions")
    @extendHash(hash)

  actionHandler: (event)->
    current_order = Groupon.Support.currentOrder

    @popup = new SupportRedemptionInstructionsPopupView()
    @popup.render()

  events :
    "click #redemption_instruction"  : "actionHandler"

module.exports = SupportRedemptionInstructionsServiceActionView
